import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

const routes = [
  { path: '/', name: 'Home', component: () => import('../views/Login.vue'),   },
  { path: '/login', name: 'Login', component: () => import('../views/Login.vue'),  },  
  { path: '/Vehicle', name: 'Vehicle', component: () => import( '../views/Vehicle.vue') },
  { path: '/VehicleDetail', name: 'VehicleDetail', component: () => import( '../views/VehicleDetail.vue'),props:true,  },
  { path: '/VehicleWrite', name: 'VehicleWrite', component: () => import( '../views/VehicleWrite.vue'),props:true,  },
  { path: '/VehicleRLS', name: 'VehicleRLS', component: () => import( '../views/VehicleRLS.vue'), },
   { path: '/VehicleRLS2', name: 'VehicleRLS2', component: () => import( '../views/VehicleRLS2.vue'), }, 
  { path: '/VehicleRlsDetail', name: 'VehicleRlsDetail', component: () => import( '../views/VehicleRlsDetail.vue'), },
  { path: '/VehicleRlsWrite', name: 'VehicleRlsWrite', component: () => import( '../views/VehicleRlsWrite.vue'), },
  { path: '/Device', name: 'Device', component: () => import( '../views/Device.vue'), },
  { path: '/DeviceDetail', name: 'DeviceDetail', component: () => import( '../views/DeviceDetail.vue'),props:true, },
  { path: '/DeviceWrite', name: 'DeviceWrite', component: () => import( '../views/DeviceWrite.vue'),props:true, },
  { path: '/Bss', name: 'Bss', component: () => import( '../views/Bss.vue'), },
  { path: '/BssDetail', name: 'BssDetail', component: () => import( '../views/BssDetail.vue'), },
  { path: '/BssWrite', name: 'BssWrite', component: () => import( '../views/BssWrite.vue'), },
  { path: '/BssLog', name: 'BssLog', component: () => import( '../views/BssLog.vue'), },
  { path: '/BssLog2', name: 'BssLog2', component: () => import( '../views/BssLog2.vue'), },
  { path: '/BssLogDetail', name: 'BssLogDetail', component: () => import( '../views/BssLogDetail.vue'), },
  { path: '/Reserve', name: 'Reserve', component: () => import( '../views/Reserve.vue'), },
  { path: '/ReserveDetail', name: 'ReserveDetail', component: () => import( '../views/ReserveDetail.vue'), },
  { path: '/Member', name: 'Member', component: () => import( '../views/Members.vue'), },
  { path: '/MemberDetail', name: 'MemberDetail', component: () => import( '../views/MemberDetail.vue'), }, 
  { path: '/MemberApproval', name: 'MemberApproval', component: () => import( '../views/MemberApproval.vue'), },
  { path: '/RequireLogin', name: 'RequireLogin', component: () => import( '../views/RequireLogin.vue'), },
  { path: '/Manager', name: 'Manager', component: () => import( '../views/Manager.vue'), },
  { path: '/ManagerDetail', name: 'ManagerDetail', component: () => import( '../views/ManagerDetail.vue'), },
  { path: '/ManagerWrite', name: 'ManagerWrite', component: () => import( '../views/ManagerWrite.vue'), },
  { path: '/Error', name: 'ServerError', component: () => import('../views/Error.vue') },
  { path: '/:catchAll(.*)', name: 'Forbidden', component: () => import('../views/Forbidden.vue') }
];

 
const router = new VueRouter({
  mode: 'history', 
  base: process.env.BASE_URL,
  routes
})


export default router
